import { createFileRoute } from '@tanstack/react-router';

import { TemplateEditPage } from '@pages/templates/template-edit-page.js';
import { IamService } from '@units/iam';

/**
 * `/templates/$templateId_/versions/$versionId/edit` — wiring only.
 *
 * Гард — `template:update`: то же право, что открывает кнопки «править черновик» / «новый
 * черновик» на карточке. Сама операция сохранения (`PATCH …/versions/{versionId}`) дополнительно
 * отвечает `409 template_version_immutable` не-`DRAFT`-версии — гард не знает статуса версии на
 * момент захода, только право её вообще редактировать.
 *
 * **Не дочерний маршрут карточки** — тот же приём `$templateId_`, что у `fill.tsx`, и по той же
 * причине: редактор несёт собственный `PageHeader` и тяжёлое дерево правки, а не встаёт вкладкой
 * внутри карточки. См. докстринг `fill.tsx` — там разбор подробный, здесь не повторяется.
 */
export const Route = createFileRoute(
  '/_authenticated/templates/$templateId_/versions/$versionId/edit',
)({
  beforeLoad: IamService.IamGuards.requirePermission({
    permission: 'template:update',
    whenDenied: 'forbidden',
  }),
  component: TemplateEditPage,
  staticData: { crumbKey: 'templates.edit.title' },
});
